import { reduce } from 'lodash';

export default function mapKeys(options) {
  return reduce(options, (acc, curr, key) => (
    curr ? [...acc, key] : acc
  ), []);
}
